<template>
    <div>
        <b-breadcrumb>
            <b-breadcrumb-item to="/student/evaluaciones">{{$t('evaluacion.label')}}</b-breadcrumb-item>
            <b-breadcrumb-item active>{{$t('evaluacion.label')}}</b-breadcrumb-item>
        </b-breadcrumb>
        <div class="card">
            <div class="card-body">
                <div class="back-step mt-0"  @click="backStep">
                    <icon name="arrow-left" />{{$t('planesYPrecios.regresar')}}
                </div>
                <h4 class="sub-title"><span>{{$t('evaluacion.sub-title-4')}}</span></h4>
                <b-row class="evaluationCourse">
                    <b-col>
                        <div class="sub-title-img">
                            <span class="blue">{{$t('evaluacion.label')}}</span>
                            <p>{{module ? module.id != '-' ? module.strModule : '-' : '-'}}</p>
                        </div>
                    </b-col >
                    <b-col>
                        <div class="sub-title-img name">
                            <img src="@/assets/img/progress-small.png">
                            <div>
                                <span class="blue">{{$t('evaluacion.sub-title-5')}}</span>
                                <p>{{course}}</p>
                            </div>
                        </div>
                    </b-col >

                    <b-col>
                        <div class="sub-title-img">
                            <span class="blue">{{$t('evaluacion.sub-title-6')}}</span>
                            <p>{{calification}}</p>
                        </div>
                    </b-col >
                </b-row>
                <div>
                    <h6 class="bold" style="font-size: 15px;">{{$t('evaluacion.sub-title-7')}}</h6>
                    <div class="section_gray text">
                        <p class="mb-0">
                            {{dataTeacher.comment}}
                        </p>
                    </div>
                </div>
                <div class="teacher-commentary">
                    <div class="d-flex align-items-center">
                        <b-avatar
                            variant="light"
                            :src="urlPhoto"
                        ></b-avatar>
                        <div class="sub-title-img">
                            <span class="blue">{{$t('evaluacion.sub-title-avatar')}}</span>
                            <p class="mb-0"> {{dataTeacher.name}}</p>
                        </div>
                    </div>
                    <p class="text-gray">
                        {{$t('evaluacion.sub-title-8')}}
                        <span>
                            {{dataTeacher.date}}
                         
                        </span>
                    </p>
              
                </div>
                <h6 class="bold" style="font-size: 15px;margin-bottom:16px;">{{$t('evaluacion.sub-title-9')}}</h6>
                <h6 class="text-course" v-for="(item, index) in  dataTeacher.files" :key="index">
                    <div class="d-flex align-items-center">
                        <icon name="file-circle" />
                       
                        <a v-if="item.status" class="blue" href="#" @click="donwload(item.id, item.name)">{{item.name}}</a>
                        <a :id="`not-link-teacher-${item.id}`" style="cursor: no-drop;"  v-else class="blue" >{{item.name}}</a>
                         <b-tooltip :target="`not-link-teacher-${item.id}`" triggers="hover">
                                {{$t('evaluacion.textTooltip')}}
                        </b-tooltip>
                    
                        <p class="p-2 text-gray"><span>{{item.strDateCreatedHour}}</span></p>
                    </div>
                   
                </h6>
            
           
     
                <b-table hover :items="items1" :fields="field1"  :busy="isBusy"   :show-empty="true"
                     :tbody-transition-props="transProps"    style="white-space: pre-line;margin-top: 10px;margin-bottom: 30px;"
                     :empty-text="$t('reusables.empty-text')">
                          <template #table-busy>
                    <div class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong> {{$t('ClassRequest.Loading')}}...</strong>
                    </div>
                </template>
                    <template #cell(files)="data">
                       
                        <div v-if="data.item.status">
                            <a class="link noBorder mr-2" @click="donwload(data.item.id, date.item.files)">{{data.item.files}}</a>
                            <icon name="arrow-table" />
                        </div>
                        <div v-else>
                            <a :id="`not-link-${data.item.id}`" class="link noBorder mr-2" style="text-decoration:none !important;cursor: no-drop;" >{{data.item.files}}</a>
                            <icon name="arrow-table" style="cursor: no-drop;" />
                             <b-tooltip :target="`not-link-${data.item.id}`" triggers="hover">
                                {{$t('evaluacion.textTooltip')}}
                            </b-tooltip>
                        </div>
                    </template>
                </b-table>
                <div class="d-flex align-items-center justify-content-center">
                    <b-button class="btn btn-primary" @click="backStep">
                        {{$t('evaluacion.buttons.back')}}
                    </b-button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { baseInstanceAxios } from '@/assets/js/axiosBase.js';
import { IMAGENES } from '@/assets/js/appConstants'; 
import { getNextClassDate } from '@/assets/js/util.js';

const lang = localStorage.getItem('lang') || 'es';

export default {
  data() {
    return {
      urlPhoto: IMAGENES.PHOTO_TEACHER_DEFAULT,
      isBusy: false,
      dataTeacher: {},
      transProps: {
        name: 'flip-list'
      },
      field1: [{
          key: 'id',
          label: this.$t('evaluations.revision.table-th.1')
        },
        {
          key: 'files',
          label: this.$t('evaluations.revision.table-th.2')
        },
        {
          key: 'date',
          label: this.$t('evaluations.revision.table-th.3')
        },
      ],
      items1: [],
      course: '',
      calification: '',
      module: {}
    }
  },
  props: {
    id: Number,
    //flagEdited: Boolean ,
    //course : String,
    //calification:String,
    //module : Object

  },
  created() {
    //console.log("$store.state.is_child :", this.$store.state)
    //console.log("this.$route.params:", this.$route.params)
    if (this.id == undefined) {
      this.$router.push({
        name: 'student/evaluaciones'
      }).catch(err => {});
    } else {
      this.getFileStudent();
    }
  },
  mounted() {
    this.$root.$on('updateReview', (data) => {
      this.id = data.id
      //this.flagEdited = data.flagEdited
      //this.calification = data.calification
      //this.course = data.course
      //this.module = data.module
      this.getFileStudent();
    })
  },
  methods: {
    donwload(idFile, fileName) {
      let headers = {
        responseType: "blob"
      }

      baseInstanceAxios.get(`${this.apiURL}/Resources/PersonsAssignmentsEvaluations/DownloadFile?idFile=${idFile}`, headers)
        .then((response) => {
          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(new Blob([response.data]));
          link.setAttribute('download', `${fileName}`);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }).catch(() => {});
    },
    getFileStudent() {
      this.isBusy = true;
      let data = {
        id: this.id,
        flagEdited: false //this.flagEdited
      }
      let format_day = "DD/MM/YYYY h:mm a";
      baseInstanceAxios
        .get(`${this.apiURL}/Resources/PersonsAssignmentsEvaluations/GetPersonsAssignmentsEvaluationsByFile`, {
          params: data
        })
        .then(response => {
          //console.log("response: ",response)
          this.dataTeacher = {
            comment: response.data.entity.teacherComments,
            name: response.data.entity.personTeacher.person.strFullName,
            date: response.data.entity.teacherCommentsDate ? getNextClassDate(response.data.entity.teacherCommentsDate, this.$store.state.user.timeZoneName, this.$moment, format_day) : "",
            files: (response.data.entity.listPersonsAssignmentsEvaluationsFilesTeacher || []).map(x => ({
              strDateCreatedHour: getNextClassDate(x.dateCreated, this.$store.state.user.timeZoneName, this.$moment, format_day),
              status: x.status,
              id: x.id,
              name: x.name
            }))

          }
          this.course = lang == "es" ? response.data.entity.subjectName : response.data.entity.subjectName_EN
          this.calification = response.data.entity.strScore
          this.module = {
            id: response.data.entity.module == null ? '-' : response.data.entity.module,
            strModule: response.data.entity.module == null ? lang == "es" ? 'Módulo 0' : "Module 0" : lang == "es" ? response.data.entity.strModule : response.data.entity.strModule_EN
          }
          //console.log("this.module: ",this.module)
          if (response.data.entity.listPersonsAssignmentsEvaluationsFiles) {
            this.items1 = response.data.entity.listPersonsAssignmentsEvaluationsFiles.map(element => ({
              id: element.id,
              files: element.name,
              url: element.urlFile,
              date: getNextClassDate(element.dateCreated, this.$store.state.user.timeZoneName, this.$moment, format_day),
              status: false
            }))
          }
          this.isBusy = false;
        });
    },
    backStep() {
      if (!this.$store.state.is_teacher) {
        //1. Desde la misma vista
        //2. Desde Historial
        //3. Avances

        if (this.$route.params.flagReport) {
          this.$router.push({
            name: 'student/evaluaciones',
            params: {
              id: this.$route.params.historyId
            }
          }).catch(() => {});
        } else {
          this.$router.push({
            name: 'student-class'
          }).catch(err => {});
        }
      } else {
        this.$router.push({
          name: 'teacher/student'
        }).catch(err => {});
      }
    }
  }
}
</script>